// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {
    getCreditMemoDisplayText,
    getCreditMemoFormName,
    getCreditMemoObjectId
} from '../../../../shared/services/credit-memo-services';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledNumber from '../../../../shared/components/labeled-number';
import LabeledSmartFormLink from '../../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasAccess} from '../../../../shared/services/security';
import {hasCreditMemoAction} from '../../../../shared/services/allowed-actions-services';

const getLabel = key =>
    key ? 'TOTAL_REIMBURSED_WITH_CURRENCY' : 'TOTAL_REIMBURSED';

const calculateDeductibleAmount = (deductible, exchangeRate) => {

    const deductibleValue = Number(deductible);
    const exchangeRateValue = Number(exchangeRate);

    if (isNaN(deductibleValue) || isNaN(exchangeRateValue)) {

        return 0;

    }
    return Math.round(deductibleValue * exchangeRateValue * 100) / 100;

};

const ClaimValueTotals = (props, context) =>
    <section className='claim-value-totals'>
        <section className='claim-value-reimbursed-local'>
            {props.showAmountsInLocalCurrency &&
                <section>
                    <LabeledCurrency
                        className='claim-value-header'
                        data={props.values.totalAmountReimbursedInLocalCurrency}
                        label={getLabel(props.values.localCurrency.key)}
                        values={{currency: props.values.localCurrency.key ? props.values.localCurrency.key : null}}
                    />
                    <LabeledCurrency
                        data={props.values.totalAmountInLocalCurrency}
                        label='VALUE'
                    />
                    <LabeledCurrency
                        data={calculateDeductibleAmount(props.values.deductible, props.values.exchangeRate)}
                        label='DEDUCTIBLE'
                    />
                    <LabeledCurrency
                        data={props.values.taxInLocalCurrency}
                        label='TAX'
                    />
                    <LabeledNumber
                        data={props.values.exchangeRate}
                        label='EXCHANGE_RATE'
                        options={{minimumFractionDigits: 5}}
                    />
                </section>
            }
        </section>
        <section className='claim-value-reimbursed'>
            <LabeledCurrency
                className='claim-value-header'
                data={props.values.totalAmountReimbursed}
                label={getLabel(props.values.currency.key)}
                values={{currency: props.values.currency.key ? props.values.currency.key : null}}
            />
            <LabeledCurrency
                data={props.values.totalAmount}
                label='VALUE'
            />
            <LabeledCurrency
                data={props.values.deductible}
                label='DEDUCTIBLE'
            />
            <LabeledCurrency
                data={props.values.tax}
                label='TAX'
            />
            {hasAccess(context.security, 'CLAIM', 'CLM_CREDIT_MEMO') && hasCreditMemoAction(props.allowedActions) &&
                <LabeledSmartFormLink
                    displayText={getCreditMemoDisplayText(props.values.creditMemoNumber)}
                    formName={getCreditMemoFormName(props.values.creditMemoNumber)}
                    label='CREDIT_MEMO'
                    objectId={getCreditMemoObjectId(props.values.creditMemoNumber, props.claimNumber)}
                />
            }
        </section>
    </section>;

ClaimValueTotals.displayName = 'ClaimValueTotals';
ClaimValueTotals.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    showAmountsInLocalCurrency: PropTypes.bool.isRequired,
    values: PropTypes.instanceOf(ClaimValueDetails).isRequired
};
ClaimValueTotals.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimValueTotals;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/claim-value-totals.js